(() => {
  'use strict';
  const protectedTypes = new Set(['customer', 'customer_login', 'guest_login', 'recover_customer_password', 'create_customer', 'contact', 'new_comment']);
  const protectedForms = () => [...document.forms].filter((form) => {
    if (form.dataset.nocaptcha === 'true') return false;
    const type = form.querySelector('[name="form_type"]')?.value || '';
    return protectedTypes.has(type);
  });
  const visible = (element) => {
    const style = getComputedStyle(element);
    const rect = element.getBoundingClientRect();
    return style.display !== 'none' && style.visibility !== 'hidden' && rect.width > 0 && rect.height > 0;
  };
  const captchaElements = () => [...document.querySelectorAll('iframe[src*="hcaptcha"], iframe[src*="captcha"], .h-captcha, [data-hcaptcha-widget-id]')].filter(visible);
  const intersects = (a, b) => a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
  const adjustWhatsapp = (captchas) => {
    const captchaRects = captchas.map((element) => element.getBoundingClientRect());
    const whatsapp = [...document.querySelectorAll('a[href*="wa.me/"], [data-whatsapp-floating], [aria-label*="WhatsApp" i], [title*="WhatsApp" i]')]
      .filter(visible)
      .filter((element) => getComputedStyle(element).position === 'fixed');
    whatsapp.forEach((element) => {
      if (!element.dataset.commerceOriginalBottom) element.dataset.commerceOriginalBottom = element.style.bottom || getComputedStyle(element).bottom || '0px';
      const rect = element.getBoundingClientRect();
      const obstacle = captchaRects.find((captchaRect) => intersects(rect, captchaRect));
      if (obstacle) element.style.setProperty('bottom', `${Math.ceil(innerHeight - obstacle.top + 14)}px`, 'important');
      else if (!captchas.length && element.dataset.commerceOriginalBottom) element.style.setProperty('bottom', element.dataset.commerceOriginalBottom);
    });
  };
  const update = () => {
    protectedForms().forEach((form) => { form.dataset.commerceFormProtection = 'shopify-managed'; });
    const captchas = captchaElements();
    const active = captchas.length > 0;
    document.documentElement.dataset.commerceCaptchaActive = active ? 'true' : 'false';
    adjustWhatsapp(captchas);
    document.dispatchEvent(new CustomEvent('commerce:form-protection-state', { detail: { active, protectedForms: protectedForms().length } }));
  };
  new MutationObserver(update).observe(document.documentElement, { subtree: true, childList: true });
  document.addEventListener('DOMContentLoaded', update, { once: true });
  window.addEventListener('resize', update, { passive: true });
  update();
})();
